module.exports = __webpack_public_path__ + "static/media/11.a1f49b36.png";